import { GET_AGENCY } from './actions'

export const getCurrentAgency = state => state.agency
export const getAgencyLoading = ({ loading }) => !!loading.get(GET_AGENCY.ACTION)
